module.exports = __webpack_public_path__ + "img/Cheer Megaphone54.1bf5367e.jpg";